"use strict";

exports.__esModule = true;
exports.types = exports.removeNotification = exports.addNotificationAfter = exports.addNotification = void 0;
var types = {
  ADD_NOTIFICATION: "[userInterfaceNotifications] Add notification",
  ADD_NOTIFICATION_AFTER: "[userInterfaceNotifications] Adds notification after saga handled request",
  REMOVE_NOTIFICATION: "[userInterfaceNotifications] Remove notification"
};
exports.types = types;

var addNotification = function addNotification(payload) {
  return {
    type: types.ADD_NOTIFICATION,
    payload: payload
  };
};

exports.addNotification = addNotification;

var addNotificationAfter = function addNotificationAfter(payload) {
  return {
    type: types.ADD_NOTIFICATION_AFTER,
    payload: payload
  };
};

exports.addNotificationAfter = addNotificationAfter;

var removeNotification = function removeNotification(payload) {
  return {
    type: types.REMOVE_NOTIFICATION,
    payload: payload
  };
};

exports.removeNotification = removeNotification;